import { render, staticRenderFns } from "./PostPinterest.vue?vue&type=template&id=aac4da1e&"
import script from "./PostPinterest.vue?vue&type=script&lang=js&"
export * from "./PostPinterest.vue?vue&type=script&lang=js&"
import style0 from "./post-pinterest.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports